import ButtonAction from "pages/Wallet/Component/ButtonAction";
import { Grid } from "@mui/material";
import { TYPES } from "pages/Deposit/constants";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

function MobileDepositTypes({ selectedCoinTypes }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { watch, setValue } = useFormContext();
  const type = watch("type");

  const handleChangeType = (val) => {
    setValue("type", val);

    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      type: val,
    });
  };

  const formattedItems = useMemo(() => {
    return selectedCoinTypes?.map((type) => ({
      value: type?.id,
      text: type?.name,
      smallText: type?.id === TYPES.paymentGateway,
    }));
  }, [selectedCoinTypes]);

  return (
    <Grid item xs={12}>
      <ButtonAction
        value={type}
        items={formattedItems}
        onChange={handleChangeType}
        buttonAction={true}
      />
    </Grid>
  );
}

export default MobileDepositTypes;
